export default "__VITE_ASSET__DNe70HV3__"